<template>
	<div class="full">
		<el-tabs class="full flex" style="flex-direction: column;" v-model="activeName" type="card">
			<el-tab-pane label="税务信息" name="first">
				<div class="pane_container">
					<tax v-if="item" :item="item" :key="'tax_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="收件信息" name="second">
				<div class="pane_container">
					<addressee v-if="item" :item="item"  :key="'addressee_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="订单明细" name="third">
				<div class="pane_container">
					<orders :item="item" ref="taborder"  :key="'orders_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="开票信息" name="fourth">
				<div class="pane_container">
					<invoice v-if="item" :item="item"  :key="'invoice_'+key" />
				</div>
			</el-tab-pane>
			<el-tab-pane label="审核品类" name="fifth">
				<div class="pane_container">
					<invoiceaudit v-if="item" :item="item"  :key="'invoiceaudit_'+key" />
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.pane_container {
		position: relative;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px;
		overflow-y: auto;
		overflow-x: hidden;
		box-sizing: border-box;
	}
</style>
<script>
	import tax from './tax.vue';
	import addressee from './addressee.vue';
	import orders from './orders.vue';
	import invoice from './invoice.vue';
	import invoiceaudit from './invoiceaudit.vue';
	export default {
		props: {
			item: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				activeName: 'first',
				key: Math.random()
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			onSubmit() {
				console.log('submit!');
			},
			reload() {
				this.key = Math.random()
			}
		},
		components: {
			tax,
			addressee,
			orders,
			invoice,
			invoiceaudit
		}
	}
</script>
